<template>
  <div>
    <div class="center-t">
      <div class="sp-odt">异议记录查询</div>
    </div>
    <div class="page-wrap">
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column type="index" width="55" label="序号" align="center">
          <template
            slot-scope="scope"
          >{{ (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column
          prop="proposeCompanyName"
          width="220"
          label="提出异议企业名称"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="companyName"
          label="被异议企业名称"
          width="180"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="type" label="类型" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ $common.getTypeText(scope.row.type)}}</template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="提交日期"
          width="120"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.createTime?scope.row.createTime.split(' ')[0]:''}}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-view"
              @click="handleView(scope.row.id)"
            >查看</el-button>
            <!-- <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row.id)"
            >修改</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>
<script>
import { objectList } from "@/api/index";
export default {
  data() {
    return {
      queryParams: {
        pageSize: 10,
        pageNum: 1
      },
      tableData: [],
      id: "",
      total: 0
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      objectList({ ...this.queryParams }).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total
      });
    },
    handleView(id){
        window.open(`/jzz/objectView?id=${id}`)
    },
    // handleEdit(id){
    //     window.open(`/applyView?id=${id}&action=update`)
    // }
  }
};
</script>
<style lang="less" scoped>
</style>